import { render, staticRenderFns } from "./AdoptionReportEditorSchool.vue?vue&type=template&id=00fba394&"
import script from "./AdoptionReportEditorSchool.vue?vue&type=script&lang=js&"
export * from "./AdoptionReportEditorSchool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports